import classNames from "classnames";
import { useMemo } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { FixedCell } from "../../../components/tables/StandardTable";
import { ThemedIcon } from "../../../components/utilities";

const HubwiseJobStageInfoCell = ({
    className,
    stage,
    processCompleted,
    completed,
    completedIn,
    warnings,
    exception,
    info,
    ...cellProps
}) => {
    const title = useMemo(() => {
        let out = stage;
        if (exception) {
            out += " - Failed"
        }
        else if (completed)
            out += ` - ${completedIn}`

        return out;
    }, [completed, completedIn, exception, stage])

    return <FixedCell className={classNames(className, "text-center")}>
        <OverlayTrigger
            overlay={
                <Popover>
                    <Popover.Header>{title}</Popover.Header>
                    <Popover.Body>
                        {
                            completed
                                ? <>
                                    {info}<br />
                                    {warnings && <><strong>Warnings:</strong> {warnings}</>}
                                </>
                                : exception || <strong>Execution Interrupted.</strong>
                        }
                    </Popover.Body>
                </Popover>
            }
        >
            {
                (completed || exception != null)
                    ? <ThemedIcon
                        icon={completed ? "circle-check" : "circle-xmark"}
                        size="lg"
                        variant={completed ? warnings ? "warning" : "success" : "danger"}
                    />
                    : <>-</>
            }
        </OverlayTrigger>

    </FixedCell>
}

export default HubwiseJobStageInfoCell;